import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';

import Iconify from '../iconify';

const AGENCY_ID_CLAIM = 'https://miami-ship/agencyId';
const DEMO_AGENCY_ID = 'DEMO';

export default function DemoBanner() {
  const { user } = useAuth0();
  const [open, setOpen] = useState(true);

  const agencyId = user?.[AGENCY_ID_CLAIM];

  if (agencyId !== DEMO_AGENCY_ID || !open) {
    return null;
  }

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: 2 }}
    >
      <Paper
        elevation={8}
        sx={{
          px: 2,
          py: 1,
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.9),
          backdropFilter: 'blur(8px)',
          color: '#fff',
          minWidth: 340,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Iconify icon="mdi:flask-outline" sx={{ color: '#ffc107', fontSize: 20 }} />
          <Chip
            label="DEMO"
            size="small"
            sx={{
              bgcolor: '#ffc107',
              color: '#000',
              fontWeight: 700,
              fontSize: 11,
              height: 22,
            }}
          />
          <IconButton size="small" onClick={() => setOpen(false)} sx={{ color: 'grey.500' }}>
            <Iconify icon="mdi:close" width={18} />
          </IconButton>
        </Stack>
      </Paper>
    </Snackbar>
  );
}
